var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:none;}\n\t.st2{fill:none;stroke:#414143;}\n\t.st3{fill:none;stroke:#414143;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{opacity:0.7;fill:none;stroke:#424243;stroke-linecap:round;stroke-linejoin:round;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.1,5h10.2v10.2H5.1V5z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 5,
    cy: 3.1,
    rx: 1.7,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.4,8.3c0-1.5-1.5-2.8-3.4-2.8S1.7,6.8,1.7,8.3"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 10,
    cy: 10,
    r: 5.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserActivity);
export default __webpack_public_path__ + "static/media/ic_user_activity.85eb854fc7794c9570fd3677b8e8faf1.svg";
export { ForwardRef as ReactComponent };